module.exports = __webpack_public_path__ + "static/ocorie-srv-splash-img-training-1b034cbd8f95f4dd28e177bc585c1dbd.png";